export const dist = {
  first_name: 50,
  last_name: 50,
  email: 255,
  phone: 10,
  company_name: 50,
  company_address: 255,
  city: 30,
  state: 15,
  zip_code: 5,
};
export const dist_user = {
  first_name: 50,
  last_name: 50,
  email: 255,
  phone: 10,
};
export const hub = {
  hub_id: 50,
};
export const dev = {
  imei_number: 15,
  iccid: 20,
};
export const profile = {
  first_name: 50,
  last_name: 50,
  phone_number: 10,
};
export const customer = {
  company_name: 50,
  company_address: 255,
  city: 30,
  state: 15,
  zip_code: 5,
};
